import { render } from "./CreateTopic.vue.js?vue&type=template&id=7d4e82d2!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreateTopic.vue?vue&type=template&id=7d4e82d2"
import script from "./CreateTopic.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreateTopic.vue?vue&type=script&lang=js"
export * from "./CreateTopic.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreateTopic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/community/CreateTopic.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d4e82d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d4e82d2', __exports__)) {
    api.reload('7d4e82d2', __exports__)
  }
  
  module.hot.accept("./CreateTopic.vue.js?vue&type=template&id=7d4e82d2!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreateTopic.vue?vue&type=template&id=7d4e82d2", () => {
    api.rerender('7d4e82d2', render)
  })

}


export default __exports__